module.exports = __webpack_public_path__ + "static/img/7.a6b1766.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/boxopen/7.png
// module id = vbID
// module chunks = 1